<!DOCTYPE html>
<div class="app-update-wrapper">
  <p class="app-update-heading">It looks like you already have an account.</p>
  <ion-button class="update-btn" (click)="signInPage()">OK</ion-button>
</div>
